// extracted by mini-css-extract-plugin
module.exports =  {"Video":"Video__LLnMs","productModalVideo":"productModalVideo__KMqg1","lazyloadThumbnail":"lazyloadThumbnail__I8hfn"};